import tryRemoveFromMailStoreItems from 'owa-mail-actions/lib/triage/tryRemoveFromMailStoreItems';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
export default function removeItemData(rowKey, tableView) {
    // For a single row key, it should never map to multiple item ids
    var messageItemId = getRowIdsFromRowKeys([rowKey], tableView.id)[0];
    // Currently, the only item data that needs cleanup is in mailstore.items
    // Try removing it if the ref is not held by other scenarios
    tryRemoveFromMailStoreItems(messageItemId, 0 /* ListViewTable */);
}
//# sourceMappingURL=removeItemData.js.map